import React from 'react';

import ProductPrice from '../Interface/ProductPrice';
import ProductCardPrice from '../ProductCard/ProductCardPrice';

import { StyledProductCardPriceContainer } from './ExtraCardPrice.style';

interface ExtraCardPrice {
  price: ProductPrice;
}

const ExtraCardPrice = ({ price }: ExtraCardPrice) => (
  <StyledProductCardPriceContainer>
    <ProductCardPrice price={price} hideDisclamer />
  </StyledProductCardPriceContainer>
);

export default ExtraCardPrice;
